import _extends from "@babel/runtime-corejs3/helpers/extends";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyNames from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import React, { useContext, useMemo } from 'react';
import { StylesContext } from '../context/styles';
import { getStyleUtil } from '../utils';
export function useStyles(directStyles, name, propStyles) {
  var context = useContext(StylesContext);

  var _ref = context || {},
      components = _ref.components,
      tokens = _ref.tokens,
      mergeClasses = _ref.mergeClasses,
      createTokenFunction = _ref.createTokenFunction;

  var styleUtil = useMemo(function () {
    return getStyleUtil({
      directStyles: directStyles,
      propStyles: propStyles,
      name: name,
      components: components,
      tokens: tokens,
      mergeClasses: mergeClasses,
      createTokenFunction: createTokenFunction
    });
  }, [components, directStyles, name, propStyles, tokens, mergeClasses, createTokenFunction]);
  return styleUtil;
}

var styled = function styled(styles) {
  return function (WrappedComponent) {
    var _context;

    var name = WrappedComponent.name || WrappedComponent.displayName;

    function StyledInner(props) {
      var styleUtil = useStyles(styles, name, props.styles);
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        styles: styleUtil
      }));
    } // HACK: apparently some third party components (i.e. airbnb's DatePicker) execute
    // functional components as functions, which breaks hooks, so we wrap the functional
    // component in another functional component to get around it here 🙈


    function Styled(props) {
      return /*#__PURE__*/React.createElement(StyledInner, props);
    } // NOTE: this is mostly for backwards compatibility when we used to have class
    // components with static properties, we want to mainain the ability to access
    // these properties on the decorated component


    var staticKeys = _filterInstanceProperty(_context = _Object$getOwnPropertyNames(WrappedComponent)).call(_context, function (key) {
      var _context2;

      return !_includesInstanceProperty(_context2 = _Object$getOwnPropertyNames(Function)).call(_context2, key);
    });

    _forEachInstanceProperty(staticKeys).call(staticKeys, function (staticKey) {
      Styled[staticKey] = WrappedComponent[staticKey];
    });

    Styled.displayName = "styled(".concat(name, ")");
    return Styled;
  };
};

export default styled;